<template lang="pug">
  div
    b-card(header="Respuestas rápidas", header-class="headerColor", header-text-variant="dark")
      b-form-group
        b-table#slashTable.m-0.overflow-y.scrollable-area(:items="fastResponses", :busy="loading", :fields="fields", @row-selected="answerSelected", @hidden="clearResponseSelection", sticky-header, selectable, responsive, show-empty, select-mode="single")
            template(v-slot:table-busy)
              .text-center
                b-spinner(variant="primary")
            template(v-slot:empty)
              p.mb-0.text-help No hay respuestas para mostrar
            template(v-slot:cell(text)="{ item }")
              .d-flex
                b-img.mr-3(:src="item.image", v-if="item.image", width="50", height="50", rounded)
                .flex-grow-1
                  .d-flex.justify-content-between
                    p.mb-0.bold {{ item.name }}
                    b-badge.ml-1(variant="light", v-if="item.category") {{ item.category }}
                  p.mb-0.text-secondary {{ item.text }}
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import debounce from 'lodash.debounce'
import { Response } from '../helpers/slashHelper'
import mixpanel from '@/mixpanel'

const caseController = createNamespacedHelpers('case')

export default {
  data () {
    return {
      fastResponses: [],
      responsesHasNextPage: false,
      loading: false,
      fields: [
        {
          key: 'text',
          label: '',
          thStyle: { display: 'none' }
        }
      ],
      selectedAnswer: null,
      table: null,
      mutableMessage: this.message,
      mutableContainer: this.container,
      responseSearch: ''
    }
  },
  props: {
    isShown: {
      type: Boolean,
      default: false
    },
    container: {
      type: HTMLTextAreaElement,
      default: null
    },
    message: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...caseController.mapState({
      case_object: (state) => state.case_object
    })
  },
  methods: {
    ...mapActions([
      'response_template/all',
      'response_template/search'
    ]),
    getResponses() {
      mixpanel.track('Slash Commands', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      });
      const { Group = {} } = this.case_object
      const { group_id: groupId } = Group || {}
      this.loading = true

      this['response_template/all']({
        account_id: this.$route.params.account_id,
        callback: (res) => {
          this.loading = false

          if (res.error) return this.$message.error(res.error)

          if (!groupId) {
            this.fastResponses = res.resource
          } else {
            const filterResponses = ({ Groups = [] }) => Groups.some(({ group_id: _groupId }) => _groupId == groupId) || !Groups.length          

            this.fastResponses = !groupId ? res.resource : res.resource.filter(filterResponses)
          }

          this.responsesHasNextPage = res.hasNextPage || false          
          setTimeout(() => {
            if(this.message.length == 1 && $('#slashTable')[0] && $('#slashTable')[0].children[0] ) $('#slashTable')[0].children[1].children[0].focus()
          }, 2000)
        }
      })
    },
    answerSelected(answer) {
      if (answer) return this.fillComposer(answer[0])
    },
    fillComposer(data) {
      if (!data) return this.clearComposer()

      const response = new Response(data, this)

      response.addText().addName().addImage().addFile()

      $('#user-message-input').focus()
      mixpanel.track('Slash Commands: Fill Composer With Selected Answer', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      });
    },
    clearComposer(type = 'all') {
      if (type === 'all' || type === 'files') this.$emit('files', [])

      if (type === 'all' || type === 'message') {
        this.mutableMessage = ''
        this.mutableContainer = ''
      }
    },
    clearResponseSelection() {
      if (this.table) return this.table.clearSelected()
    },
    searchResponse: debounce(function () {
      if (!this.message) return
      const self = this

      this['response_template/search']({
        params: {
          account_id: self.$route.params.account_id,
          search: self.message
        },
        callback: (res) => {
          self.hideLoadingScreen()

          if (res.error) return self.$message.error(res.error)

          self.fastResponses = res.resource
          self.responsesHasNextPage = res.hasNextPage || false

          if (!self.fastResponses.length){
            this.getResponses()
          } else{
            this.$nextTick(() => {            
              $('#slashTable')[0].children[1].children[0].focus()
            })
          }

        }
      })
    }, 500)
  },
  watch: {
    mutableMessage: function () {
      this.$emit('mutableMessage', this.mutableMessage)
    },
    mutableContainer: function () {
      this.$emit('mutableContainer', this.mutableContainer)
    },
    message: function () {
      const regex = /^\/[A-Za-z0-9\s]+$/gi

      if (this.message.match(regex)) this.searchResponse()
    }
  },
  mounted () {
    this.table = document.getElementById('table')
    window.dataLayer = window.dataLayer || [];

    // Registra el evento
    window.dataLayer.push({
      event: 'slash_commands', // Reemplaza 'nombre_del_evento' con el nombre que desees
      // Agrega aquí cualquier propiedad adicional que desees enviar con el evento
      account_id: this.$route.params.account_id,
      admin_id: this.getCurrentUser().admin_id,
    })
    
    this.getResponses()
  }
}
</script>

<style lang="scss">
.headerColor {
  background-color: #ccdcff;
}

tr:focus {
  background-color: #ccdcff !important;
}
</style>
